var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import { boundingBox, createCircle, createHoleCutout, createRectangle, } from "../utilities/geometry";
import { isCirclePolygonData, isRectanglePolygonData, } from "../utilities/partcreation";
import { isNumber, } from "../utilities/wsi4_typeguards";
import GeneralInformationView from "../../components/partcreation/generalinformationview.vue";
let HoleCutout = class HoleCutout extends Vue {
    constructor() {
        super(...arguments);
        this.currentBoundingBox = {
            lower: {
                entries: [
                    (0.),
                    (0.),
                ],
            },
            upper: {
                entries: [
                    (0.),
                    (0.),
                ],
            },
        };
        this.elements = [];
    }
    validInput(valid) { return valid; }
    transferHoleData() {
        return this.path;
    }
    updateData() {
        if (this.validNumbers) {
            this.transferHoleData();
        }
        this.validInput(this.valid);
    }
    createBoundingBox(path) {
        return boundingBox(path);
    }
    addElement() {
        let holeDimX = 0.;
        let holeDimY = 0.;
        if (isRectanglePolygonData(this.outerPolygonData)) {
            holeDimX = this.outerPolygonData.dimX / 2.;
            holeDimY = this.outerPolygonData.dimY / 2.;
        }
        this.elements.push({
            holeDimX: holeDimX,
            holeDimY: holeDimY,
            holeRadius: this.shopConfig.minimalScrewDiameter * 0.5,
        });
        this.updateData();
    }
    removeElement(index) {
        this.elements.splice(index, 1);
        this.updateData();
    }
    distanceBetweenPoints(center1, center2) {
        return Math.sqrt(Math.pow(center1.entries[0] - center2.entries[0], 2) + Math.pow(center1.entries[1] - center2.entries[1], 2));
    }
    holeDiameterValid(index) {
        return this.elements[index].holeRadius * 2. >= this.shopConfig.minimalScrewDiameter;
    }
    isValidNumber(n) { return isNumber(n); }
    holeRadiusValid(index) {
        if (!this.isValidNumber(this.elements[index].holeRadius)) {
            return false;
        }
        let outerWidth = 0;
        if (isCirclePolygonData(this.outerPolygonData)) {
            outerWidth = this.outerPolygonData.radius * 2.;
        }
        else {
            outerWidth = Math.min(this.outerPolygonData.dimX, this.outerPolygonData.dimY);
        }
        if (this.elements[index].holeRadius * 2. >= outerWidth - 2. * this.outerPolygonData.thickness || !this.holeDiameterValid(index)) {
            return false;
        }
        return true;
    }
    holeDimXValid(index) {
        if (!this.isValidNumber(this.elements[index].holeDimX)) {
            return false;
        }
        let outerDim = 0;
        const thickness = this.outerPolygonData.thickness;
        if (isCirclePolygonData(this.outerPolygonData)) {
            outerDim = this.outerPolygonData.radius;
        }
        else {
            if (this.elements[index].holeDimX <= thickness + this.elements[index].holeRadius) {
                return false;
            }
            outerDim = this.outerPolygonData.dimX;
        }
        if (Math.abs(this.elements[index].holeDimX) + this.elements[index].holeRadius >= outerDim - thickness) {
            return false;
        }
        return true;
    }
    holeDimYValid(index) {
        if (!this.isValidNumber(this.elements[index].holeDimY)) {
            return false;
        }
        let outerDim = 0;
        const thickness = this.outerPolygonData.thickness;
        if (isCirclePolygonData(this.outerPolygonData)) {
            outerDim = this.outerPolygonData.radius;
        }
        else {
            if (this.elements[index].holeDimY <= thickness + this.elements[index].holeRadius) {
                return false;
            }
            outerDim = this.outerPolygonData.dimY;
        }
        if (Math.abs(this.elements[index].holeDimY) + this.elements[index].holeRadius >= outerDim - thickness) {
            return false;
        }
        return true;
    }
    isInsideOuterPolygon(center, radius) {
        if (isCirclePolygonData(this.outerPolygonData)) {
            return this.distanceBetweenPoints(center, {
                entries: [
                    0.,
                    0.,
                ],
            }) + this.outerPolygonData.thickness + radius < this.outerPolygonData.radius;
        }
        if (!isRectanglePolygonData(this.outerPolygonData)) {
            return false;
        }
        const upperX = this.currentBoundingBox.upper.entries[0];
        const upperY = this.currentBoundingBox.upper.entries[1];
        const lowerX = this.currentBoundingBox.lower.entries[0];
        const lowerY = this.currentBoundingBox.lower.entries[1];
        if ((center.entries[0] - radius) <= (lowerX + this.outerPolygonData.thickness)) {
            return false;
        }
        if ((center.entries[1] - radius) <= (lowerY + this.outerPolygonData.thickness)) {
            return false;
        }
        if ((center.entries[0] + radius) >= (upperX - this.outerPolygonData.thickness)) {
            return false;
        }
        if ((center.entries[1] + radius) >= (upperY - this.outerPolygonData.thickness)) {
            return false;
        }
        if (radius >= this.outerPolygonData.cornerRadius - this.outerPolygonData.thickness) {
            return true;
        }
        const lowerLeftCornerMiddlePoint = {
            entries: [
                lowerX + this.outerPolygonData.cornerRadius,
                lowerY + this.outerPolygonData.cornerRadius,
            ],
        };
        const upperLeftCornerMiddlePoint = {
            entries: [
                lowerX + this.outerPolygonData.cornerRadius,
                upperY - this.outerPolygonData.cornerRadius,
            ],
        };
        const lowerRightCornerMiddlePoint = {
            entries: [
                upperX - this.outerPolygonData.cornerRadius,
                lowerY + this.outerPolygonData.cornerRadius,
            ],
        };
        const upperRightCornerMiddlePoint = {
            entries: [
                upperX - this.outerPolygonData.cornerRadius,
                upperY - this.outerPolygonData.cornerRadius,
            ],
        };
        if (this.distanceBetweenPoints(lowerLeftCornerMiddlePoint, center) < this.outerPolygonData.cornerRadius - radius) {
            return true;
        }
        if (this.distanceBetweenPoints(upperLeftCornerMiddlePoint, center) < this.outerPolygonData.cornerRadius - radius) {
            return true;
        }
        if (this.distanceBetweenPoints(lowerRightCornerMiddlePoint, center) < this.outerPolygonData.cornerRadius - radius) {
            return true;
        }
        if (this.distanceBetweenPoints(upperRightCornerMiddlePoint, center) < this.outerPolygonData.cornerRadius - radius) {
            return true;
        }
        {
            if (center.entries[0] < lowerLeftCornerMiddlePoint.entries[0] && center.entries[1] < lowerLeftCornerMiddlePoint.entries[1]) {
                return false;
            }
            if (center.entries[0] < upperLeftCornerMiddlePoint.entries[0] && center.entries[1] > upperLeftCornerMiddlePoint.entries[1]) {
                return false;
            }
            if (center.entries[0] > lowerRightCornerMiddlePoint.entries[0] && center.entries[1] < lowerRightCornerMiddlePoint.entries[1]) {
                return false;
            }
            if (center.entries[0] > upperRightCornerMiddlePoint.entries[0] && center.entries[1] > upperRightCornerMiddlePoint.entries[1]) {
                return false;
            }
        }
        return true;
    }
    noOverlapInnerPolygons(center1, center2, radius1, radius2) {
        return this.distanceBetweenPoints(center1, center2) > radius1 + radius2 + this.outerPolygonData.thickness;
    }
    isNotOverlapping(index) {
        for (let j = 0; j < this.elements.length; j++) {
            if (!(j === index)) {
                if (!this.noOverlapInnerPolygons({
                    entries: [
                        this.elements[index].holeDimX,
                        this.elements[index].holeDimY,
                    ],
                }, {
                    entries: [
                        this.elements[j].holeDimX,
                        this.elements[j].holeDimY,
                    ],
                }, this.elements[index].holeRadius, this.elements[j].holeRadius)) {
                    return false;
                }
            }
        }
        return true;
    }
    toolTipHoleRadius(index) {
        if (!this.isValidNumber(this.elements[index].holeRadius)) {
            return this.i18n.t("holeInputNumberWarning");
        }
        let outerWidth = 0;
        if (isCirclePolygonData(this.outerPolygonData)) {
            outerWidth = this.outerPolygonData.radius * 2.;
        }
        else {
            outerWidth = Math.min(this.outerPolygonData.dimX, this.outerPolygonData.dimY);
        }
        if (this.elements[index].holeRadius * 2. >= outerWidth - 2. * this.outerPolygonData.thickness) {
            return this.i18n.t("holeSmallerOuterPolygon");
        }
        if (!this.holeRadiusValid(index)) {
            return "Hole diameter minimum is " + this.shopConfig.minimalScrewDiameter.toString() + " mm";
        }
        return "";
    }
    toolTipHoleDimX(index) {
        if (!this.isValidNumber(this.elements[index].holeDimX)) {
            return this.i18n.t("holeInputNumberWarning");
        }
        let outerWidth = 0;
        const thickness = this.outerPolygonData.thickness;
        if (isCirclePolygonData(this.outerPolygonData)) {
            outerWidth = this.outerPolygonData.radius;
        }
        else {
            if (this.elements[index].holeDimX <= thickness + this.elements[index].holeRadius) {
                return this.i18n.t("inputThicknessWarning");
            }
            outerWidth = this.outerPolygonData.dimX;
        }
        if (Math.abs(this.elements[index].holeDimX) + this.elements[index].holeRadius >= outerWidth - thickness) {
            return this.i18n.t("holeInsideOuterPolygon");
        }
        return "";
    }
    toolTipHoleDimY(index) {
        if (!this.isValidNumber(this.elements[index].holeDimY)) {
            return this.i18n.t("holeInputNumberWarning");
        }
        let outerWidth = 0;
        const thickness = this.outerPolygonData.thickness;
        if (isCirclePolygonData(this.outerPolygonData)) {
            outerWidth = this.outerPolygonData.radius * 2.;
        }
        else {
            if (this.elements[index].holeDimY <= thickness + this.elements[index].holeRadius) {
                return this.i18n.t("inputThicknessWarning");
            }
            outerWidth = this.outerPolygonData.dimY;
        }
        if (Math.abs(this.elements[index].holeDimY) + this.elements[index].holeRadius >= outerWidth - thickness) {
            return this.i18n.t("holeInsideOuterPolygon");
        }
        return "";
    }
    get validNumbers() {
        for (let i = 0; i < this.elements.length; i++) {
            if (!this.isValidNumber(this.elements[i].holeRadius)) {
                return false;
            }
            if (!this.isValidNumber(this.elements[i].holeDimX)) {
                return false;
            }
            if (!this.isValidNumber(this.elements[i].holeDimY)) {
                return false;
            }
        }
        return true;
    }
    get valid() {
        for (let i = 0; i < this.elements.length; i++) {
            if (!(this.holeRadiusValid(i) && this.holeDimXValid(i) && this.holeDimYValid(i))) {
                return false;
            }
            if (!(this.isNotOverlapping(i) && this.isInsideOuterPolygon({
                entries: [
                    this.elements[i].holeDimX,
                    this.elements[i].holeDimY,
                ],
            }, this.elements[i].holeRadius))) {
                return false;
            }
        }
        return true;
    }
    get generalErrorMessage() {
        for (let i = 0; i < this.elements.length; i++) {
            if (!(this.holeRadiusValid(i) && this.holeDimXValid(i) && this.holeDimYValid(i))) {
                return "";
            }
            if (!this.isInsideOuterPolygon({
                entries: [
                    this.elements[i].holeDimX,
                    this.elements[i].holeDimY,
                ],
            }, this.elements[i].holeRadius)) {
                return this.i18n.t("holeInsideOuterPolygon");
            }
            if (!this.isNotOverlapping(i)) {
                return this.i18n.t("holeElementsOverlap");
            }
        }
        return "";
    }
    get path() {
        const path = [];
        for (const p of this.elements) {
            path.push(createHoleCutout(p.holeDimX, p.holeDimY, p.holeRadius));
        }
        return path;
    }
    onProjectEntryChanged() {
        if (isRectanglePolygonData(this.outerPolygonData)) {
            if (this.outerPolygonData.cornerRadius * 2. > Math.min(this.outerPolygonData.dimX, this.outerPolygonData.dimY)) {
                this.validInput(false);
            }
            else {
                this.currentBoundingBox = this.createBoundingBox(createRectangle(this.outerPolygonData.dimX, this.outerPolygonData.dimY, this.outerPolygonData.cornerRadius));
                this.validInput(this.valid);
            }
        }
        else if (isCirclePolygonData(this.outerPolygonData)) {
            this.currentBoundingBox = this.createBoundingBox(createCircle(this.outerPolygonData.radius));
            this.validInput(this.valid);
        }
        else {
            this.validInput(false);
        }
    }
};
__decorate([
    Prop({ required: true })
], HoleCutout.prototype, "outerPolygonData", void 0);
__decorate([
    Prop({ required: true })
], HoleCutout.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], HoleCutout.prototype, "i18n", void 0);
__decorate([
    Emit()
], HoleCutout.prototype, "validInput", null);
__decorate([
    Emit()
], HoleCutout.prototype, "transferHoleData", null);
__decorate([
    Watch("outerPolygonData")
], HoleCutout.prototype, "onProjectEntryChanged", null);
HoleCutout = __decorate([
    Component({
        components: {
            GeneralInformationView,
        },
        name: "HoleCutout",
    })
], HoleCutout);
export default HoleCutout;
